import api, { Notifiable } from '../api';

const controller = 'crfContratadoPcm';

export interface CrfPedidoFormulario {
    numeroCentroCustoFormulario?: string;
    codigoCentroCustoFormulario?: string;
    nomeCentroCustoFormulario?: string;
    statusModuloEconomicoFormulario?: string[];

    acronimoAgrupadorFormulario?: string;
    codigoAgrupadorFormulario?: string;
    codigoContaContabilFormulario?: string;

    numeroRequisicaoCompraFormulario?: string
    numeroItemRequisicaoCompraFormulario?: string;
    dataRequisicaoCompraFormulario?: string;
    statusRequisicaoCompraFormulario?: string[];

    numeroOrdemCompraFormulario?: string;
    dataEmissaoOrdemCompraFormulario?: string;

    numeroPedidoCompraFormulario?: string;
    tipoPedidoCompraFormulario?: string;
    nomeFornecedorPedidoCompraFormulario?: string;
    dataPedidoCompraFormulario?: string;

    numeroContratoPcsFormulario?: string;
}


export interface CrfPedidomaterialResult extends Notifiable {
    row: number;
    id: string;
    crfContaContabilCcRcSeqId: string;
    agrupador: string;
    contaContabilCodigo: string;
    contaContabilNome: string;
    ocData: string;
    ocNumero: string;
    ocNumeroFormatado: string;
    pacoteCodigo: string;
    pacoteNome: string;
    pacoteNumero: string;
    projetoNome: string;
    projetoNumero: string;
    projetoNumeroInt: string;
    rcNarrativa: string;
    rcNumero: string;
    rcNumeroFormatado: string;
    rcSeq: string;
    rcSeqFormatado: string;
    rcStatus: string;
}

export const getFilterPedidoMateriais = (values: CrfPedidoFormulario) => {
    var query = "";

    query += values.numeroCentroCustoFormulario ? "numeroCentroCusto=" + values.numeroCentroCustoFormulario : "";
    query += values.codigoCentroCustoFormulario ? "&codigoCentroCusto=" + values.codigoCentroCustoFormulario : "";
    query += values.nomeCentroCustoFormulario ? "&nomeCentroCusto=" + values.nomeCentroCustoFormulario : "";
    query += values.statusModuloEconomicoFormulario ? "&statusModuloEconomico=" + values.statusModuloEconomicoFormulario.join('&statusModuloEconomico=') : "";

    query += values.acronimoAgrupadorFormulario ? "&acronimoAgrupador=" + values.acronimoAgrupadorFormulario : "";
    query += values.codigoAgrupadorFormulario ? "&codigoAgrupador=" + values.codigoAgrupadorFormulario : "";
    query += values.codigoContaContabilFormulario ? "&codigoContaContabil=" + values.codigoContaContabilFormulario : "";

    query += values.numeroRequisicaoCompraFormulario ? "&numeroRequisicaoCompra=" + values.numeroRequisicaoCompraFormulario : "";
    query += values.numeroItemRequisicaoCompraFormulario ? "&numeroItemRequisicaoCompra=" + values.numeroItemRequisicaoCompraFormulario : "";
    query += values.statusRequisicaoCompraFormulario ? "&statusRequisicaoCompra=" + values.statusRequisicaoCompraFormulario.join('&statusRequisicaoCompra=') : "";
    query += values.dataRequisicaoCompraFormulario ? "&dataRequisicaoCompra=" + values.dataRequisicaoCompraFormulario : "";

    query += values.numeroOrdemCompraFormulario ? "&numeroOrdemCompra=" + values.numeroOrdemCompraFormulario : "";
    query += values.dataEmissaoOrdemCompraFormulario ? "&dataEmissaoOrdemCompra=" + values.dataEmissaoOrdemCompraFormulario : "";

    query += values.numeroPedidoCompraFormulario ? "&numeroPedidoCompra=" + values.numeroPedidoCompraFormulario : "";
    query += values.tipoPedidoCompraFormulario ? "&tipoPedidoCompra=" + values.tipoPedidoCompraFormulario : "";
    query += values.nomeFornecedorPedidoCompraFormulario ? "&nomeFornecedorPedidoCompra=" + values.nomeFornecedorPedidoCompraFormulario : "";
    query += values.dataPedidoCompraFormulario ? "&dataPedidoCompra=" + values.dataPedidoCompraFormulario : "";

    query = query.replace(/^&/, '');
    return api.get<CrfPedidomaterialResult[]>(`${controller}/materiais?${query}`);
};


export const deleteCrfDistribuicaoItemPedido = (crfContaContabilCcRequisicaoCompraSeqId: any): Promise<Notifiable> =>
    api.delete<Notifiable>(`${controller}/deleteDistribuicaoItem/${crfContaContabilCcRequisicaoCompraSeqId}`) as Promise<Notifiable>;

export const atualizarValorCrfContratadoAnoPedido = (
    moduloEconomicoContratadoId: any,
    crfContaContabilCcId: any,
    requisicaoCompraSeqId: any,
    quantidade: string,
    ano: string,
) => {
    const form = new FormData();
    form.append('moduloEconomicoContratadoId', moduloEconomicoContratadoId);
    form.append('crfContaContabilCcId', crfContaContabilCcId);
    form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
    form.append('quantidade', quantidade);
    form.append('ano', ano);
    form.append('anoTexto', ano);

    return api.post<any>(`${controller}/atualizarValorContratadoAno`, form);
};

export const adicionarCrfLinhaItemRateavelPedido = (
    crfContaContabilCcId: any,
    crfContaContabilCcRcSeqId = "",
    crfRequisicaoCompraSeqId = "") => {

    const form = new FormData();
    form.append('crfContaContabilCcId', crfContaContabilCcId);
    form.append('crfContaContabilCcRcSeqId', crfContaContabilCcRcSeqId);
    form.append('crfRequisicaoCompraSeqId', crfRequisicaoCompraSeqId);
    return api.post<any>(`${controller}/adicionarLinhaItemRateavel`, form);
};

export const concluirCrfRateioctPcmPedido = (crfContaContabilCcRequisicaoCompraSeqId: string) => {
    const form = new FormData();
    form.append('crfContaContabilCcRequisicaoCompraSeqId', crfContaContabilCcRequisicaoCompraSeqId);
    return api.post<any>(`${controller}/ConcluirRateioctPedido`, form);
};
